import { render, staticRenderFns } from "./PhotoView.vue?vue&type=template&id=74d96ed0&scoped=true&"
import script from "./PhotoView.vue?vue&type=script&lang=ts&"
export * from "./PhotoView.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoView.vue?vue&type=style&index=0&id=74d96ed0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d96ed0",
  null
  
)

export default component.exports